import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FilePreviewPipe } from '@smartera/pipes';

@Component({
	selector: 'file-preview',
	imports: [FilePreviewPipe, AsyncPipe],
	template: `
		@if (file?.type.startsWith('application/pdf')) {
			<iframe
				[src]="file | filePreview | async"
				class="preview-pdf"
				title="PDF Preview"
				width="100%"
				height="100%"></iframe>
		} @else {
			<img [src]="file | filePreview | async" alt="Dosya önizlemesi" class="preview-image" width="100%" height="100%" />
		}
	`,
})
export class FilePreviewComponent {
	@Input({ required: true }) file: File;
}
